import axios, { AxiosResponse } from 'axios';
import router from '../router';
import { ElLoading, ElMessageBox } from 'element-plus'
import { MD5Encrypt, NewGuid } from './Encrypt';
import zh from '../assets/language/zh-cn.json'
import ls from './localStorage';
///基础的Post请求
export async function Post(url: string, data: Object): Promise<AxiosResponse<any, any>> {
    var config = {
        baseURL: '/api/',
        method: 'post',
        maxBodyLength: Infinity,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    let response = (await axios(config));
    return response;
}

///加入回调的Post请求
export async function doPost(url: string, data: Object, successAction: Function = () => { }, failAction: Function = () => { }, tokenErrorAction: Function = () => { }, completeAction: Function = () => { }) {
    let response = await Post(url, data);
    if (response.status == 200) {
        let result = response.data;
        if (result.resultStatus == 1) {
            successAction(result.data);
        } else if (result.resultStatus == -2) {
            tokenErrorAction(result.msg);
        }
        else {
            failAction(result.msg);
        }
    } else {
        failAction(response.statusText);
    }
    completeAction();
}



//自动处理失败回调 和等待图标的Post请求
export async function GoPost(url: string, data: Object, successAction: Function = () => { }, langPack: any = zh) {
    let loading = ElLoading.service({
        lock: true,
        text: langPack.loading,
        background: 'rgba(0, 0, 0, 0.7)',
    })
    doPost(url, data,
        (successData: any) => {
            loading.close()
            successAction(successData)
        },
        (failMsg: string) => {
            loading.close()
            ElMessageBox.alert(failMsg, langPack.error, {
                confirmButtonText: langPack.confirm
            })
        },
        (tokenErrorMsg: string) => {
            loading.close()
            ElMessageBox.alert(tokenErrorMsg, langPack.error, {
                confirmButtonText: langPack.confirm
            })
            router.push("/Login");
        },
        () => {
            loading.close()
        })
}

export async function SqlManipulate(code: string, param: Object, successAction: Function = () => { }) {
    let guid = NewGuid();
    let tokenstr = "code=" + code + "&param=" + JSON.stringify(param) + "&timestamp=" + guid;
    let token = MD5Encrypt(tokenstr).toUpperCase();
    let data = {
        Token: token,
        timestamp: guid,
        code: code,
        ModuleId: ls.get("ModuleId"),
        Params: JSON.stringify(param),
        isOfficial: false
    }
    await GoPost("/sql/ClientPost", data, successAction);
}

export function GetImg(param: string, successAction: Function = () => { }) {
    let moduleId = ls.get("ModuleId");
    let img = param;
    let guid = NewGuid();
    let tokenstr = "code=" + moduleId + "&param=" + param + "&timestamp=" + guid;
    let token = MD5Encrypt(tokenstr).toUpperCase();
    let url = "https://www.fengtop.com.cn/api/FileUpload/GetImg";
    url += "?moduleId=" + moduleId;
    url += "&img=" + img;
    url += "&Token=" + token;
    url += "&timestamp=" + guid;

    successAction(url)
}

export function GetImgs(datas:Array<Object>){
    datas.forEach(data=>{
        let IMG_1=Reflect.get(data,"IMG_1") as string;
        if(IMG_1!=undefined&&IMG_1!=""){
            if(IMG_1.startsWith('/upload/')){
                GetImg(IMG_1,(result:string)=>{
                    Reflect.set(data,"IMG_1",result);
                })
            }
        }
    })
}

export function GetSImgs(datas:Array<Object>){
    datas.forEach(data=>{
        let IMG_1=Reflect.get(data,"IMG_1") as string;
        if(IMG_1!=undefined&&IMG_1!=""){
            if(IMG_1.startsWith('/upload/')){
                let lastdotIndex = IMG_1.lastIndexOf('.');
                let pre = IMG_1.substring(0, lastdotIndex);
                let extname=IMG_1.substring(lastdotIndex,IMG_1.length);
                let url_server_s = pre + "_s" + extname;
                GetImg(url_server_s,(result:string)=>{
                    Reflect.set(data,"IMG_1_S",result);
                })
            }
        }
    })
}

